import { createContext } from 'react';

export type InvoicePdfReadyContextValue = {
  notifyCombinedGroupRendered: () => void;
  allCombinedGroupsRendered: boolean;
};

const InvoicePdfReadyContext = createContext<InvoicePdfReadyContextValue>({
  notifyCombinedGroupRendered: () => {},
  /** Default true so SubtotalRow does not block PdfReady when no provider is present */
  allCombinedGroupsRendered: true,
});

export default InvoicePdfReadyContext;
